const TOOLTIP_ANCHOR = '[data-tooltip-id], [data-tooltip-content], [data-tooltip-html]'

const stripTitleFromAnchor = (el: Element) => {
    if (!(el instanceof HTMLElement)) return
    if (el.hasAttribute('title')) {
        el.removeAttribute('title')
    }
    el.querySelectorAll('[title]').forEach((child) => {
        if (child instanceof HTMLElement) {
            child.removeAttribute('title')
        }
    })
}

const stripInRoot = (root: ParentNode) => {
    if (root instanceof Element && root.matches(TOOLTIP_ANCHOR)) {
        stripTitleFromAnchor(root)
    }
    root.querySelectorAll?.(TOOLTIP_ANCHOR).forEach(stripTitleFromAnchor)
}

/** Prefer react-tooltip; drop native browser titles on the same control so hover is not duplicated. */
export const startSuppressNativeTitleWhenTooltip = (): (() => void) => {
    stripInRoot(document)

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'title') {
                const target = mutation.target
                if (
                    target instanceof Element &&
                    (target.closest(TOOLTIP_ANCHOR) || target.matches(TOOLTIP_ANCHOR))
                ) {
                    stripTitleFromAnchor(target.closest(TOOLTIP_ANCHOR) || target)
                }
                continue
            }
            mutation.addedNodes.forEach((node) => {
                if (node instanceof Element || node instanceof DocumentFragment) {
                    stripInRoot(node)
                }
            })
        }
    })

    observer.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['title', 'data-tooltip-id', 'data-tooltip-content', 'data-tooltip-html'],
    })

    return () => observer.disconnect()
}
